import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import { withRouter, useParams } from "react-router-dom";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
// import TaskDetails from "src/modules/3rd-party-management/components/RisksAndTasks/tasks/details";
import TaskDetails from "src/modules/data-protection/components/RisksAndTasks/tasks/details";
import Navigator from "src/components/Navigator";
import { useQuery } from "@tanstack/react-query";
import ControlService from "src/modules/data-protection/apis/ControlService";
import { toast } from "react-toastify";
import { useMemo, useState } from "react";
import { formatTaskAndRiskId } from "src/modules/data-protection/constants";

const TaskDetailsPage = ({ t, location }) => {
    const { taskId } = useParams();
    const searchQuery = new URLSearchParams(location.search);
    const controlId = searchQuery.get('controlId');
    const CService = ControlService.getInstance();
    const [taskData, setTaskData] = useState(null);

    const fetchControlDetails = useQuery({
        queryKey: [
            'gdpr-fetch-control-details',
            controlId
        ],
        queryFn: async () => {
            return await CService.details(controlId);
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        enabled: controlId ? true : false,
        onError: () => {
            toast(t('Failed to load the control details.'), {
                type: 'error'
            });
        }
    });

    const breadCrumbs = useMemo(() => {
        if(!controlId) {
            return [
                {
                    title: 'SIP',
                    link: '/admin/data-protection/dashboard'
                },
                {
                    title: 'Controls',
                    link: '/admin/data-protection/controls'
                }
            ]
        }

        return [
            {
                title: 'SIP',
                link: '/admin/data-protection/dashboard'
            },
            {
                title: 'Controls',
                link: '/admin/data-protection/controls'
            },
            {
                title: fetchControlDetails?.data?.title || '...',
                link: `/admin/data-protection/controls/${controlId}/tasks`
            },
            {
                title: 'Tasks',
                link: `/admin/data-protection/controls/${controlId}/tasks`
            },
            {
                title: 'Detail',
                link: '#'
            }
        ]        
    }, [ 
        controlId,
        fetchControlDetails
    ])

    const taskTitle = taskData ? formatTaskAndRiskId(
        'task',
        taskData?.questionnaire === "software" ? taskData?.asset_id : taskData?.case_secondary_id,
        taskData.secondary_id,
        taskData?.is_mitigation,
        taskData?.questionnaire,
        taskData.secondary_id
    ) : '...';

    return (
        <div className='page-content'>
            <Container fluid>
                <Row>
                    <Col lg="12" className="mb-4">
                        <Navigator 
                            backButtonOptions={(props) => {
                                return {
                                    ...props,
                                    enable  :   true
                                }
                            }} 
                            breadCrumbs={breadCrumbs}
                            pageTitle={taskTitle}
                            translate={false}
                        />
                    </Col>

                    <Col sm="12">
                        <Card>
                            <CardBody>
                                <TaskDetails 
                                    taskId={ taskId }
                                    onTaskDataFetched={(data) => setTaskData(data)}
                                    showBackButton={false}
                                    onRelatedTaskClicked={(id) => {
                                        console.log('ok')
                                    }}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    )
};

const mapStatetoProps = (state) => {
    const { token } = state.Login;
    const { Organization } = state;
    return {
        user            :   state.Login.user,
        token,
        organization    :   Organization
    };
};

export default withNamespaces()(
    withRouter(connect(
        mapStatetoProps,
        {}
    )(TaskDetailsPage))
);